<!-- Mobile Overlay -->
@if (isMobileOpen()) {
<div class="fixed inset-0 bg-gray-900/50 z-40 lg:hidden backdrop-blur-sm transition-opacity duration-300"
  (click)="closeMobileMenu.emit()"></div>
}

<!-- Sidebar Container -->
<div
  class="fixed lg:static inset-y-0 left-0 z-50 bg-white flex flex-col flex-shrink-0 border-r border-gray-200 transform transition-all duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] h-full"
  [class.translate-x-0]="isMobileOpen()" [class.-translate-x-full]="!isMobileOpen()" [class.lg:translate-x-0]="true"
  [class.w-56]="!isCollapsed()" [class.w-20]="isCollapsed()">
  <!-- Header -->
  <div
    class="h-16 flex items-center bg-gradient-to-r from-indigo-700 to-indigo-600 shadow-md flex-shrink-0 transition-all duration-300 relative overflow-hidden"
    [class.justify-center]="isCollapsed()" [class.justify-between]="!isCollapsed()" [class.px-6]="!isCollapsed()">
    <!-- Background Pattern -->
    <div class="absolute inset-0 opacity-10 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')]">
    </div>

    <div class="relative z-10 flex items-center">
      @if (!isCollapsed()) {
      <h1 class="text-xl font-extrabold text-white tracking-wider uppercase truncate">WEBPOS</h1>
      } @else {
      <h1 class="text-xl font-extrabold text-white tracking-wider uppercase">W</h1>
      }
    </div>

    <!-- Mobile Close Button -->
    <button (click)="closeMobileMenu.emit()"
      class="lg:hidden text-indigo-100 hover:text-white transition-colors relative z-10">
      <app-icon name="x" size="24"></app-icon>
    </button>

    <!-- Desktop Collapse Button -->
    <button (click)="onToggleCollapse()"
      class="hidden lg:block text-indigo-200 hover:text-white transition-colors p-1.5 rounded hover:bg-white/10 relative z-10"
      [title]="isCollapsed() ? 'Expand Sidebar' : 'Collapse Sidebar'">
      @if (isCollapsed()) {
      <app-icon name="panel-left-open" size="20"></app-icon>
      } @else {
      <app-icon name="panel-left-close" size="20"></app-icon>
      }
    </button>
  </div>

  <!-- User Profile -->
  <!-- <button (click)="onNavigateToProfile()"
    class="flex items-center flex-shrink-0 transition-colors text-left w-full outline-none group border-b border-gray-100"
    [class.justify-center]="isCollapsed()" [class.p-4]="isCollapsed()" [class.p-4]="!isCollapsed()"
    [class.gap-3]="!isCollapsed()" [class.bg-indigo-50]="isActive('/profile')"
    [class.hover:bg-indigo-50/50]="!isActive('/profile')" title="Admin User">
    <div
      class="w-10 h-10 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center font-bold shadow-md text-white ring-2 ring-white group-hover:ring-indigo-200 transition-all flex-shrink-0">
      {{ userName?.charAt(0)}}
    </div>
    @if (!isCollapsed()) {
    <div class="overflow-hidden flex-1 min-w-0">
      <p class="text-sm font-semibold truncate transition-colors" [class.text-indigo-700]="isActive('/profile')"
        [class.text-gray-800]="!isActive('/profile')" [class.group-hover:text-indigo-700]="!isActive('/profile')">{{
        'sidebar.adminUser' | translate }}</p>
      <p class="text-xs text-gray-500 truncate flex items-center gap-1.5">
        <span class="w-1.5 h-1.5 rounded-full bg-green-500"></span>
        {{userName}}
      </p>
    </div>
    }
  </button> -->

  <!-- Navigation -->
  <nav class="flex-1 overflow-y-auto py-3 custom-scrollbar overflow-x-hidden bg-gray-50/30">
    <ul class="space-y-1 px-2">
      @for (item of menuItems(); track item.id) {
      <li>
        <button (click)="onNavigate(item.route)" (click)="onNavigate(item.route)"
          class="w-full flex items-center transition-all duration-200 group rounded-lg relative overflow-hidden h-12"
          [class.justify-center]="isCollapsed()" [class.px-3]="isCollapsed()" [class.px-4]="!isCollapsed()"
          [class.gap-3]="!isCollapsed()" [class.hover:bg-white]="!isActive(item.route)"
          [class.hover:text-gray-900]="!isActive(item.route)" [class.hover:shadow-sm]="!isActive(item.route)"
          [class.cursor-not-allowed]="!item.route" [class.hover:shadow-none]="!item.route"
          [title]="isCollapsed() ? (item.label | translate) : ''" [disabled]="!item.route">
          @if (isActive(item.route)) {
          <div class="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-indigo-600 rounded-r-full"></div>
          }

          <app-icon [name]="item.iconName" [size]="'20'" [strokeWidth]="isActive(item.route) ? '2' : '1.5'"
            class="transition-colors flex-shrink-0" [class.text-indigo-600]="isActive(item.route)"
            [class.text-gray-400]="!isActive(item.route)"
            [class.group-hover:text-indigo-500]="!isActive(item.route) && !!item.route"></app-icon>

          @if (!isCollapsed()) {
          <span class="truncate" [class.font-semibold]="isActive(item.route)">{{ item.label |
            translate }}</span>
          }
        </button>
      </li>
      }
    </ul>
  </nav>

  <!-- Footer -->
  <div class="p-4 border-t border-gray-200 bg-white flex-shrink-0">
    @if (!isCollapsed()) {
    <div class="bg-gradient-to-r from-gray-50 to-white rounded-lg border border-gray-200 p-3 mb-3 shadow-sm">
      <div class="flex items-center gap-2 mb-1.5">
        <app-icon name="credit-card" size="14" class="text-indigo-600"></app-icon>
        <span class="fs-12 font-bold uppercase text-gray-500 tracking-wider truncate">{{ 'SYSMESER0026' |
          translate }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span class="relative flex h-2.5 w-2.5 flex-shrink-0">
          <span
            class="animate-ping absolute inline-flex h-full w-full rounded-full bg-{{ colorVan() }}-400 opacity-75"></span>
          <span
            class="relative inline-flex rounded-full h-2.5 w-2.5 bg-{{ colorVan() }}-500 border border-white"></span>
        </span>
        <span class="fs-12 font-semibold text-gray-700 truncate">{{ (colorVan() == 'green' ? 'SYSMESER0027' :
          'SYSMESER0028') | translate }}</span>
      </div>
    </div>
    }
    <button (click)="onLogout()"
      class="w-full flex items-center bg-gray-200 shadow-sm  font-medium text-red-600 hover:bg-red-50 hover:text-red-700 rounded-lg transition-colors border border-transparent hover:border-red-100"
      [class.justify-center]="isCollapsed()" [class.p-3]="isCollapsed()" [class.gap-3]="!isCollapsed()"
      [class.px-4]="!isCollapsed()" [class.py-2.5]="!isCollapsed()" [title]="'SYSMESER0013' | translate">
      <app-icon name="log-out" [size]="isCollapsed() ? '20' : '18'"></app-icon>
      @if (!isCollapsed()) {
      <span>{{ 'SYSMESER0013' | translate }}</span>
      }
    </button>
  </div>
</div>